/**
 * screens/Reconciliation/emptyState.ts
 * Copy for the reconciliation panel — empty, and gated on variance routing.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const RECON_FLOW: readonly FlowNode[] = [
  { key: 'assign', label: 'Assign', sub: 'cash into custody' },
  { key: 'record', label: 'Record', sub: 'spends and collections' },
  { key: 'count', label: 'Count', sub: 'prove the balance', here: true },
  { key: 'route', label: 'Route', sub: 'to Payroll or Billing' },
];

export const RECON_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'Count the cash',
    hint: 'A limit count measures against the target; a collection counts owed, collected and deposited.',
  },
  {
    n: '2',
    label: 'The difference is named',
    hint: 'Matched, short, or over. Nothing is quietly absorbed.',
  },
  {
    n: '3',
    label: 'Route it or waive it',
    hint: 'A shortfall goes to Payroll, a surplus to Billing. A waive needs a reason.',
  },
];

export const RECON_COPY = {
  eyebrow: 'Reconciliation',
  title: 'No cash has been counted yet',
  blurb:
    'A count is what turns a balance into a fact. Every difference leaves a consequence for Payroll or Billing, or a written reason for waiving it.',
  flowNote:
    'Variance is never absorbed. That is why this screen cannot open until routing says where a shortfall and a surplus each go.',
  gateNote: 'A count with nowhere to post its difference would leave the money unexplained.',
  footNote: 'Record a count from any assignment in the register.',
} as const;
